<template>
      <v-list>
        <template v-for="item in menuItems">
          <v-layout
            row
            v-if="item.heading"
            align-center
            :key="item.heading"
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
            value="item.active"
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title v-bind:to="item.action">
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              @click=""
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" :to="item.action">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
</v-list>
</template>
  
<script>
// import wpApi from '../../modules/api/app.service'

export default {
  mounted () {
    // this.getMenu()
  },
  data () {
    return {
      menu: [],
      loaded: false,
      menuId: 1
    }
  },
  computed: {
    menuItems () {
      let menuItems = [
        {icon: 'work', text: 'User List', action: '/user-list'},
        {icon: 'work', text: 'Issue Request', action: '/issue-type'}
        // {
        //   icon: 'keyboard_arrow_up',
        //   'icon-alt': 'keyboard_arrow_down',
        //   text: 'Labels',
        //   model: true,
        //   children: [
        //     { icon: 'add', text: 'Create label', link: '/signup' }
        //   ]
        // },
        // {
        //   icon: 'keyboard_arrow_up',
        //   'icon-alt': 'keyboard_arrow_down',
        //   text: 'More',
        //   model: false,
        //   children: [
        //     { text: 'Import' },
        //     { text: 'Export' },
        //     { text: 'Print' },
        //     { text: 'Undo changes' },
        //     { text: 'Other contacts' }
        //   ]
        // },
        // { icon: 'settings', text: 'Settings', link: '/signup' },
        // { icon: 'chat_bubble', text: 'Send feedback', link: '/signup' },
        // { icon: 'help', text: 'Help', link: '/signup' },
        // { icon: 'phonelink', text: 'App downloads', link: '/signup' },
        // { icon: 'keyboard', text: 'Go to the old version', link: '/signup' }
      ]
      return menuItems
    }
  },
  methods: {
    // getMenu () {
    //   const self = this
    //   self.loaded = false
    //   wpApi.getMenu(this.menuId).then((menu) => {
    //     console.log(menu)
    //     this.menu = menu
    //     this.loaded = true
    //   }).catch(error => {
    //     console.log(error)
    //   })
    // }
  }
}
</script>


// WEBPACK FOOTER //
// Menu.vue?9da24600